module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_type_kimono@3x-bb3a220de3989bdc7b6512c48f992713.webp";